import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class PrivateLibraryPackageService {

  constructor(private _apiService: ApiService) { }

  getPackage() {
    return this._apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.PLAYLIST)
  }

  createPackage(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PLAYLIST}`
    return this._apiService.post(url, data)
  }

  editPackage(id, data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PLAYLIST}/${id}`
    return this._apiService.put(url, data)
  }

  publishPackage(data, value) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PUBLISH_PLAYLIST}/${value}${API_ENDPOINTS.API.PUBLISH_PACKAGE}`
    return this._apiService.put(url, data)
  }

  checkCollectionForPublish(value){
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PUBLISH_PLAYLIST}/${value}${API_ENDPOINTS.API.SAME_COLLECTION_PUBLISHED}`
    return this._apiService.get(url)
  }

  getCollectionBySlug(slug){
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PLAYLIST}${API_ENDPOINTS.API.COLLECTION_BY_SLUG}/${slug}`
    return this._apiService.get(url);
  }

  getRelatedCollections(id){
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PLAYLIST}/${id}/related_collections`
    return this._apiService.get(url);
  }

}
